import {Routes, Route, Navigate} from 'external/react' 

import DayView from './Calendar/Day'
import WeekView from './Calendar/Week'
import MonthView from './Calendar/Month'
import CalendarContainer from './Calendar/Container'

import useSession from 'hooks/session'

export default function Schedule() {
  const {navigation} = useSession()
  return (
    <Routes>
      <Route element={<CalendarContainer />}>
        <Route path="month" element={<MonthView />} />
        <Route path="week" element={<WeekView />} />
        <Route path="day" element={<DayView />} />
        <Route path="/" element={
          <Navigate to={navigation.scheduleView.link({scheduleView: 'month'})} replace />}
        />
      </Route>
    </Routes>
  )
}